
/**
 * Normalizes waveform data by finding the max amplitude,
 * scaling all points relative to it, and applying a power curve
 * to boost quieter parts for better visual density.
 * 
 * @param rawPeaks - Array of raw waveform data points (usually -1 to 1 or 0 to 1)
 * @returns Normalized array of values between 0 and 1
 */
export const normalizeWaveform = (rawPeaks: number[]): number[] => {
    if (!rawPeaks || rawPeaks.length === 0) return []

    let max = 0
    for (let p of rawPeaks) {
        if (Math.abs(p) > max) max = Math.abs(p)
    }
    if (max === 0) max = 1

    return rawPeaks.map(p => {
        const norm = Math.abs(p) / max
        // Power curve (0.7) boosts low values to make waveform look "fatter"
        return Math.pow(norm, 0.70)
    })
}

/**
 * Generates a random fake waveform for loading states or missing data.
 * @param count - Number of points to generate
 * @returns Array of random numbers
 */
export const generateFakeWaveform = (count: number = 100): number[] => {
    return Array(count).fill(0).map(() => Math.random() * 0.3)
}

/**
 * Helper to standardise getting a proxied URL
 */
// getProxiedUrl is exported from app/utils/proxy.ts — auto-imported by Nuxt
